var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/function-component-definition */
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import BackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite';
import LoadingButton from '@mui/lab/LoadingButton';
import Typography from '@mui/material/Typography';
import { useQuery } from '../../hooks';
import { MatchPlayers } from '../../components/organisms/MatchPlayers';
import { loadMatch, verifyMatchPayment } from '../../api';
import { EMatchStatus } from '../../types';
import { Alerts } from '../../components/molecules/Alerts/Alerts';
import { PageWrapperNew } from '../../components/atoms/PageWrapper';
import { Delimiter } from '../../components/atoms/Delimiter';
import { ModalNew } from '../../components/atoms/Modal/Modal';
import { CreatePlayer } from '../../components/molecules/CreatePlayer/CreatePlayer';
import { AddPlayers } from '../../components/organisms/AddPlayers/AddPlayers';
import { DataContainerNew } from '../../components/atoms/DataContainer';
import { CopyPlayers } from '../../components/molecules/CopyPlayers/CopyPlayers';
import { useAsyncExecAction } from '../../hooks/useAsyncExecAction';
import { MatchStart } from '../../components/molecules/MatchStart/MatchStart';
const buttonCommonStyle = {
    marginBottom: '5px',
};
const Header = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const MatchInfoContainer = styled.div `
  display: flex;
  flex-direction: column;
  //margin-bottom: 47px;
`;
const MatchPasswordContainer = styled.div `
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
const MatchPasswordLabel = styled.div `
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.8);
`;
const MatchPassword = styled.div `
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: #000;
`;
const PlusButtons = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  width: fit-content;
`;
const PlayerButton = styled.button `
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0;
  border: 0;
  outline: none;
  background: transparent;
  color: #ffd643;

  svg {
    transition: all 0.3s;
    width: 28px;
    height: 28px;
    stroke: #ffd643;
    fill: #ffd643;
  }

  &:hover,
  &:active {
    color: #efaf0b;

    svg {
      fill: #efaf0b;
      stroke: #efaf0b;
    }
  }

  &:disabled {
    cursor: initial;
    color: #6d9c99;

    svg {
      stroke: #6d9c99;
      fill: #6d9c99;
    }
  }
`;
const PlayerText = styled.div `
  transition: all 0.3s;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: inherit;
  margin-left: 4px;
`;
export const MatchConfig = () => {
    const nav = useNavigate();
    const { param: matchId } = useQuery('matchId');
    const [match, setMatch] = useState(null);
    const [viewCreatePlayer, setViewCreatePlayer] = useState(false);
    const [viewAddPlayers, setViewAddPlayers] = useState(false);
    const [viewCopyPlayers, setViewCopyPlayers] = useState(false);
    const [matchStart, setMatchStart] = useState(false);
    const [forceAdjustOrder, setForceAdjustOrder] = useState(false);
    const [playersChanged, setPlayersChanged] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const { execAsyncAction } = useAsyncExecAction();
    const matchAction = () => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield loadMatch(matchId || '');
        setMatch(result);
    });
    const getMatch = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!matchId)
            return;
        yield execAsyncAction({ action: matchAction });
    });
    useEffect(() => {
        getMatch();
    }, [matchId]);
    const onClickAddPlayers = () => {
        // nav(`/add-players-to-match?matchId=${matchId}`)
        setViewAddPlayers(true);
    };
    const onClickCloseAddPlayers = () => {
        setViewAddPlayers(false);
    };
    const onClickCreatePlayer = () => {
        // console.log('MatchConfig createPlayer')
        setViewCreatePlayer(true);
    };
    const onClickBack = () => {
        if (match)
            nav(`/matches?eventId=${match.eventId}`);
    };
    const verifyPaymentAction = () => __awaiter(void 0, void 0, void 0, function* () {
        yield verifyMatchPayment(matchId || '');
    });
    const onClickStartMatch = () => __awaiter(void 0, void 0, void 0, function* () {
        if ((match === null || match === void 0 ? void 0 : match.status) === EMatchStatus.INGAME) {
            nav(`/match?matchId=${matchId}`);
        }
        if ((match === null || match === void 0 ? void 0 : match.status) === EMatchStatus.ENDED) {
            nav(`/match?matchId=${matchId}`);
        }
        setMatchStart(true);
    });
    const executeMatchStart = () => __awaiter(void 0, void 0, void 0, function* () {
        setMatchStart(false);
        const pay = yield execAsyncAction({ action: verifyPaymentAction });
        if (match && pay) {
            // dispatch(api.setMatch(match))
            nav(`/match?matchId=${match === null || match === void 0 ? void 0 : match.id}`);
        }
    });
    const onMatchStartClose = () => __awaiter(void 0, void 0, void 0, function* () {
        setMatchStart(false);
    });
    const onCloseCreatePlayer = () => {
        // console.log('MatchConfig onCloseAddPlayer')
        setViewCreatePlayer(false);
    };
    const onClickCopyPlayers = () => {
        setViewCopyPlayers(true);
    };
    const onClickCloseCopyPlayers = () => {
        setViewCopyPlayers(false);
    };
    // console.log('MatchConfig playersChanged', playersChanged)
    return (_jsxs(DataContainerNew, { children: [_jsx(Alerts, {}), viewCreatePlayer && (_jsx(ModalNew, Object.assign({ onClose: onCloseCreatePlayer, close: true }, { children: _jsx(CreatePlayer, { matchId: matchId, setPlayersChanged: setPlayersChanged, onClose: onCloseCreatePlayer }) }))), viewAddPlayers && (_jsx(ModalNew, Object.assign({ onClose: onClickCloseAddPlayers, close: true }, { children: _jsx(AddPlayers, { matchId: matchId, setPlayersChanged: setPlayersChanged, onClose: onClickCloseAddPlayers }) }))), viewCopyPlayers && (_jsx(ModalNew, Object.assign({ onClose: onClickCloseCopyPlayers, close: true }, { children: _jsx(CopyPlayers, { match: match, setPlayersChanged: setPlayersChanged, onClose: onClickCloseCopyPlayers }) }))), matchStart && (_jsx(ModalNew, Object.assign({ onClose: onMatchStartClose, close: true }, { children: _jsx(MatchStart, { onStart: executeMatchStart, onSetOrder: () => setForceAdjustOrder(true), onClose: onMatchStartClose }) }))), _jsxs(PageWrapperNew, { children: [_jsx(Button, Object.assign({ sx: { width: 'fit-content' }, startIcon: _jsx(BackIcon, {}), onClick: onClickBack }, { children: "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u0432 \u043A\u043B\u0443\u0431" })), _jsx(Delimiter, { top: "49px" }), _jsx(Header, { children: _jsxs(MatchInfoContainer, { children: [_jsx(Typography, Object.assign({ variant: "h2" }, { children: (match === null || match === void 0 ? void 0 : match.name) || '' })), _jsxs(MatchPasswordContainer, { children: [_jsx(Typography, Object.assign({ variant: "subtitle1" }, { children: "\u041F\u0430\u0440\u043E\u043B\u044C \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430:" })), _jsx(Delimiter, { right: "3px" }), _jsx(Typography, Object.assign({ variant: "subtitle1" }, { children: (match === null || match === void 0 ? void 0 : match.password) || '' }))] })] }) }), _jsx(Delimiter, { top: "30px" }), _jsx(MatchPlayers, { matchId: matchId, changed: playersChanged, setChanged: setPlayersChanged, forceAdjustWindowOpened: forceAdjustOrder, orderSet: () => setForceAdjustOrder(false), setDisabled: setDisabled }), _jsx(Delimiter, { top: "20px" }), _jsxs(PlusButtons, { children: [_jsxs(LoadingButton, Object.assign({ sx: buttonCommonStyle, variant: "contained", loading: !match, startIcon: _jsx(PlayCircleFilledWhiteIcon, {}), onClick: onClickStartMatch, disabled: disabled }, { children: [(match === null || match === void 0 ? void 0 : match.status) === EMatchStatus.CREATED && 'Начать игру', (match === null || match === void 0 ? void 0 : match.status) === EMatchStatus.INGAME && 'Перейти к игре', (match === null || match === void 0 ? void 0 : match.status) === EMatchStatus.ENDED && 'Перейти к статистике'] })), _jsx(Button, Object.assign({ sx: buttonCommonStyle, startIcon: _jsx(ControlPointIcon, {}), onClick: onClickAddPlayers, disabled: disabled }, { children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u043E\u0432" })), _jsx(Button, Object.assign({ sx: buttonCommonStyle, startIcon: _jsx(ContentCopyIcon, {}), onClick: onClickCopyPlayers, disabled: disabled }, { children: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u0437 \u043F\u0440\u043E\u0448\u0435\u0434\u0448\u0435\u0439 \u0438\u0433\u0440\u044B" })), _jsx(Button, Object.assign({ sx: buttonCommonStyle, startIcon: _jsx(PersonAddIcon, {}), onClick: onClickCreatePlayer, disabled: disabled }, { children: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043D\u043E\u0432\u043E\u0433\u043E \u0438\u0433\u0440\u043E\u043A\u0430" }))] })] })] }));
};
